module.exports = __webpack_public_path__ + "media/assets/icons/flat-arrow-down-c1b47569e59dea8198ca62e12a7e973a.svg";